import { createErrorReporter } from './error-reporting'
import { getContextId } from './get-context-id'

import { name } from 'package.json'

import coreAnalytics from '@nrk/core-analytics'

export class Spesialmodul extends HTMLElement {
  simpleErrorReport
  coreAnalyticsTracker

  constructor() {
    super()
    this.simpleErrorReport = createErrorReporter(
      name || '',
      this.errorTracking.enabled,
      this.errorTracking.url
    )
    this.simpleErrorReport.listenAndCatch()

    this.coreAnalyticsTracker = coreAnalytics.create()
    this.coreAnalyticsTracker('initialize', {
      trackerName: 'dh',
      container: this,
      parentId: getContextId(window.location.href),
      ga: this.dataset.gaPropertyId
    })

    this.coreAnalyticsTracker('context', {
      title: this.metadata.title,
      contentId: this.metadata.selfId,
      publishDate: this.metadata.published
    })

    this.sendGaEvent({ eventAction: 'MOUNT' })
  }

  sendError = message => {
    this.simpleErrorReport.sendErrorReport({ message })
  }

  sendGaEvent = event => {
    this.coreAnalyticsTracker('event', {
      ga: {
        eventCategory: `dh-modul-${name}`,
        ...event
      }
    })
  }

  get metadata() {
    return this.dataset.metadata ? JSON.parse(this.dataset.metadata) : {}
  }

  get preloadedState() {
    return this.dataset.preloadedState ? JSON.parse(this.dataset.preloadedState) : null
  }

  get errorTracking() {
    return {
      url: this.getAttribute('data-catch-server-url'),
      enabled: this.getAttribute('data-error-tracking-enabled') === 'true'
    }
  }
}
